import React from 'react';
import CategoryTabs from '../../components/investigation/CategoryTabs';

/** @typedef {'all'|'infrastructure'|'legal'|'breaches_risk'|'key_persons'|'web_press'|'reviews'} CorporateFeedFilterId */

export const CORPORATE_FEED_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'infrastructure', label: 'Infrastructure' },
  { id: 'legal', label: 'Legal & Registry' },
  { id: 'breaches_risk', label: 'Breaches & Risk' },
  { id: 'key_persons', label: 'Key Persons' },
  { id: 'web_press', label: 'Web & Press' },
  { id: 'reviews', label: 'Reviews' },
];

/**
 * Quick category filter bar for Corporate Due Diligence feed.
 *
 * @param {{
 *   activeFilter: CorporateFeedFilterId,
 *   onFilterChange: (id: CorporateFeedFilterId) => void,
 *   counts: Record<string, number>,
 * }} props
 */
export default function CorporateFeedFilters({ activeFilter = 'all', onFilterChange, counts = {} }) {
  return (
    <CategoryTabs
      filters={CORPORATE_FEED_FILTERS}
      activeFilter={activeFilter}
      onFilterChange={onFilterChange}
      counts={counts}
      ariaLabel="Corporate result categories"
      testId="corporate-feed-filters"
      dangerFilterId="breaches_risk"
      hideZeroCounts
      mobileEssentialIds={['all', 'infrastructure', 'breaches_risk']}
    />
  );
}
